module.exports = __webpack_public_path__ + "assets/file.b6e6159e.svg";